import React, { useCallback } from 'react';
import Layout from '../Layout';
import Header from './Header';
import Body from './Body';

const HomeworkHelp = () => {
  return (
    <Layout
      header={useCallback(
        () => (
          <Header />
        ),
        []
      )}
      body={Body}
      hasGenericFooter={true}
    />
  );
};

export default HomeworkHelp;
